import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { Client } from '../../../projects/kiene-core/src/lib/components/client/classes/client';
import { WarenkorbService } from '../wa-wi/warenkorb/warenkorb.service';

@Component({
    selector: 'kiene-laboratory',
    templateUrl: './laboratory.component.html',
    styleUrls: ['./laboratory.component.scss'],
})
export class LaboratoryComponent implements OnInit {
    currentUrl = '';
    currentClient: Client;
    embedded = false;

    constructor(
        private localStorageService: LocalStorageService,
        private router: Router,
        private route: ActivatedRoute,
        private warenkorbService: WarenkorbService,
    ) {
        // Laborleitung (1082): Warenkorb in der Toolbar – Backend filtert nur Labor-/Diagnostik-Zeilen
        // (1082 ohne 1081 = „nur ihr“ Labor-Warenkorb). Praxis-only (1771) bleibt hier ohne Icon.
        const showLaborWarenkorb = this.localStorageService.hasPermission(1082);
        this.localStorageService.setShoppingCartVisible(showLaborWarenkorb, 'LaboratoryComponent');
        this.currentUrl = this.router.url;
        if (this.route.snapshot.data['embedded']) {
            this.embedded = this.route.snapshot.data['embedded'];
        }
    }

    ngOnInit() {
        this.currentClient = this.localStorageService.getCurrentClient();
        this.localStorageService.watchCurrentClient().subscribe(client => {
            this.currentClient = client;
        });
        if (this.localStorageService.hasPermission(1082)) {
            this.warenkorbService.updateShoppingCartBadge();
        }
    }

    isTabMenuVisible(path: string) {
        return this.localStorageService.currentUserCanSeeTab(path);
    }

    isBelegeMenu(): boolean {
        return this.currentUrl.startsWith('/belege');
    }
}
